import { axiosClient, AxiosError } from 'utils/gql/axios/AxiosClient';

/** Will set defaults to the global axios object, use only for headers that should be always present */
export function assignGlobalDefaultHeaders(headers: Record<string, string>) {
  Object.assign(axiosClient.defaults.headers.common, headers);
}

export function isAxiosError<T>(result: unknown | AxiosError<T>): result is AxiosError<T> {
  if (!result) {
    return false;
  }
  return typeof result === 'object' && 'isAxiosError' in result;
}
